module.exports = __webpack_public_path__ + "static/media/icons-ic-demo-stroke.505f6129.svg";